module.exports = __webpack_public_path__ + "static/media/cartaz-1.4750c78e.png";